"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseMainModule = /** @class */ (function () {
    function FuseMainModule() {
    }
    return FuseMainModule;
}());
exports.FuseMainModule = FuseMainModule;
